import React, { Component }  from 'react';
import Section from "./Section";
import FixedButton from "./FixedButton";
import ViewSelector from "./ViewSelector";
import DetailsDialog from './DetailsDialog';
import Metrika from './Metrika';
import UsageViewer from './UsageViewer';
import FiltersDialog from './FiltersDialog';
import CloseablePanel from "./CloseablePanel";
import ExceptionsViewer from "./ExceptionsViewer";

export default class HomePage extends Component{
    state={

    };
    constructor(props) {
        super(props);
    }
    render(){
    return <div>
        <FiltersDialog/>
        <DetailsDialog expectedResult='USER_SESSIONS' previousResult='DATE_USERS'/>
        <Section id='home'>
            <div>
                <CloseablePanel type="metrika">
                    <Metrika />
                </CloseablePanel>
            </div>
        </Section>
        <Section id='usage'>
            <div>
                <CloseablePanel type="usage">
                    <UsageViewer />
                </CloseablePanel>
            </div>
        </Section>
        <Section id='exceptions'>
            <div>
                <CloseablePanel type="exceptions">
                    <ExceptionsViewer />
                </CloseablePanel>
            </div>
        </Section>
        <Section id='content'>
            <div className='system-container'>
                <CloseablePanel type="dateusers">
                    <ViewSelector />
                </CloseablePanel>
            </div>
        </Section>
        <div className="up-button">
            <FixedButton id="home" src="../images/buttons/up_gray.png" srcOn="../images/buttons/up_on.png"/>
        </div>
    </div> ;
    }
}

